module.exports = __webpack_public_path__ + "static/media/a-4-c.5215b8f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-4-c.jpg
// module id = 1102
// module chunks = 33